import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import { useCompany } from '../../../context/CompanyContext';
import './Header.css';

const Header = () => {
  const { user, logout } = useAuth();
  const { company, companies, setSelectedCompany, isSuperAdmin } = useCompany();
  const navigate = useNavigate();
  const [showCompanyDropdown, setShowCompanyDropdown] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowCompanyDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = async () => {
    await logout();
    navigate('/admin/login');
  };

  const handleSelectCompany = (c) => {
    setSelectedCompany(c);
    setShowCompanyDropdown(false);
  };

  return (
    <header className="admin-header">
      <div className="header-content">
        <div className="header-left">
          <h1 className="page-title">Panel de Administración</h1>
        </div>

        <div className="header-right">
          {company && (
            <div className="company-selector-wrapper" ref={dropdownRef}>
              {isSuperAdmin && companies.length > 1 ? (
                <div
                  className="company-selector company-selector-dropdown"
                  onClick={() => setShowCompanyDropdown(!showCompanyDropdown)}
                >
                  <span className="company-name">{company.name || company.id || 'Empresa'}</span>
                  <span className="company-selector-arrow">▼</span>
                  {showCompanyDropdown && (
                    <div className="company-dropdown-menu">
                      {companies.map((c) => (
                        <div
                          key={c.id}
                          className={`company-dropdown-item ${c.id === company.id ? 'active' : ''}`}
                          onClick={() => handleSelectCompany(c)}
                        >
                          {c.name}
                          {c.nit && <span className="company-nit"> ({c.nit})</span>}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ) : (
                <div className="company-selector">
                  <span className="company-name">{company.name || company.id || 'Empresa'}</span>
                </div>
              )}
            </div>
          )}

          <div className="user-menu">
            <div className="user-menu-trigger">
              <div className="user-avatar-small">
                {user?.firstName?.[0]}{user?.lastName?.[0]}
              </div>
              <span className="user-name-header">{user?.fullName}</span>
            </div>

            <div className="user-menu-dropdown">
              <div className="user-menu-item" onClick={handleLogout}>
                <span>🚪</span>
                <span>Cerrar Sesión</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;

